/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type LazyImageWrapper_item = {|
  +photos: ?$ReadOnlyArray<?{|
    +placeholder: ?string;
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LazyImageWrapper_item",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        }
      ],
      "concreteType": "ItemPhoto",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "placeholder",
          "storageKey": null
        }
      ],
      "storageKey": "photos{\"limit\":1}"
    }
  ],
  "type": "Item"
};

module.exports = fragment;
